import { GraphqlSorting } from '@/shared/constants/graphql-sorting';

export type UrlSortValue =
  | 'featured'
  | 'bestselling'
  | 'newest'
  | 'alphaasc'
  | 'alphadesc'
  | 'priceasc'
  | 'pricedesc'
  | 'relevance';

export type SortOption = {
  label: string;
  enumValue: GraphqlSorting;
  urlValue: UrlSortValue;
};

export class SortMappings {
  static options: SortOption[] = [
    { label: 'Featured Items', enumValue: GraphqlSorting.FEATURED, urlValue: 'featured' },
    { label: 'Best Selling', enumValue: GraphqlSorting.BEST_SELLING, urlValue: 'bestselling' },
    { label: 'Newest', enumValue: GraphqlSorting.NEWEST, urlValue: 'newest' },
    { label: 'A to Z', enumValue: GraphqlSorting.A_TO_Z, urlValue: 'alphaasc' },
    { label: 'Z to A', enumValue: GraphqlSorting.Z_TO_A, urlValue: 'alphadesc' },
    { label: 'Price: Ascending', enumValue: GraphqlSorting.LOWEST_PRICE, urlValue: 'priceasc' },
    { label: 'Price: Descending', enumValue: GraphqlSorting.HIGHEST_PRICE, urlValue: 'pricedesc' },
  ] as const;

  static getOptions(includeRelevance: boolean): SortOption[] {
    if (!includeRelevance) return this.options;
    return [
      ...this.options,
      { label: 'Relevance', enumValue: GraphqlSorting.RELEVANCE, urlValue: 'relevance' },
    ] as const;
  }

  static getEnumFromUrl(urlValue?: string | null): GraphqlSorting {
    if (!urlValue) return GraphqlSorting.FEATURED;
    const norm = String(urlValue).toLowerCase();
    const direct = this.options.find((o) => o.urlValue === (norm as UrlSortValue));
    if (direct) return direct.enumValue;
    if (norm === 'relevance') return GraphqlSorting.RELEVANCE;
    return GraphqlSorting.FEATURED;
  }

  static getUrlFromEnum(enumValue: GraphqlSorting): UrlSortValue {
    const found = this.options.find((o) => o.enumValue === enumValue);
    if (found) return found.urlValue;
    if (enumValue === GraphqlSorting.RELEVANCE) return 'relevance';
    return 'featured';
  }

  static getLabelFromEnum(enumValue: GraphqlSorting): string {
    const found = this.options.find((o) => o.enumValue === enumValue);
    if (found) return found.label;
    if (enumValue === GraphqlSorting.RELEVANCE) return 'Relevance';
    return 'Featured Items';
  }
}
